import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { useRouter } from '@atlassian/jira-router';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import { KnowledgeBaseBreadcrumb } from '@atlassian/jira-servicedesk-knowledge-common';
import { toCategoryGuid } from '@atlassian/jira-servicedesk-knowledge-common/src/common/types';
import KnowledgeHubAppBase from '@atlassian/jira-spa-apps-knowledge-hub-app-base-v2';

const KnowledgeHubCategoryApp = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "knowledge-hub-category-modern" */ '@atlassian/jira-servicedesk-knowledge-hub-category'
		),
);

const View = () => {
	const [{ match: matchRouter }] = useRouter();
	return (
		<KnowledgeHubAppBase appName={APP_NAMES.KB_CATEGORY}>
			{({ projectId, projectKey, locale, activationId }) => (
				<KnowledgeBaseBreadcrumb projectKey={projectKey}>
					<KnowledgeHubCategoryApp
						projectId={projectId}
						projectKey={projectKey}
						categoryId={toCategoryGuid(matchRouter.params?.categoryId || '')}
						locale={locale}
						activationId={activationId}
					/>
				</KnowledgeBaseBreadcrumb>
			)}
		</KnowledgeHubAppBase>
	);
};

export default View;
